import { useEffect } from 'react';
import { BaseSelect, BaseSelectProps } from '../BaseSelect';

export type LanguageSelectProps = BaseSelectProps & {
  passengerId: string;
  selectedLanguages?: Record<string, string>;
  setSelectedLanguages?: (languages: Record<string, string>) => void;
  setLastSelectedLanguage?: (language: string) => void;
};

export function LanguageSelect({
  passengerId,
  value,
  selectedLanguages = {},
  setSelectedLanguages,
  setLastSelectedLanguage,
  ...props
}: LanguageSelectProps) {
  useEffect(() => {
    if (value && setSelectedLanguages) {
      setSelectedLanguages({ ...selectedLanguages, [passengerId]: value });
      if (value !== selectedLanguages?.[passengerId]) {
        setLastSelectedLanguage?.(value);
      }
    }
  }, [value, passengerId]);

  return (
    <BaseSelect
      {...props}
      value={value}
    />
  );
}
